import {  createTheme } from '@fluentui/react';
export const NettechTheme = createTheme({
    palette: {
        themePrimary: '#005695',
        themeLighterAlt: '#f1f7fb',
        themeLighter: '#c8deee',
        themeLight: '#9cc3df',
        themeTertiary: '#4c8fbf',
        themeSecondary: '#1366a1',
        themeDarkAlt: '#004e85',
        themeDark: '#004270',
        themeDarker: '#003053',
        neutralLighterAlt: '#faf9f8',
        neutralLighter: '#f3f2f1',
        neutralLight: '#edebe9',
        neutralQuaternaryAlt: '#e1dfdd',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c6c4',
        neutralTertiary: '#a19f9d',
        neutralSecondary: '#605e5c',
        neutralPrimaryAlt: '#3b3a39',
        neutralPrimary: '#323130',
        neutralDark: '#201f1e',
        black: '#000000',
        white: '#ffffff',
    }
});